// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.general.location.PracticeLocationAccessCodeResponse */
/* istanbul ignore next */
@GandalfModel
export class PracticeLocationAccessCodeResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	accessCodeId!: number | null;

	@GandalfProperty({ designType: String })
	code!: string | null;

	@GandalfProperty({ designType: String })
	name!: string | null;

	@GandalfConstantDecorator(constants.AccessCodeStatus)
	@GandalfProperty({ designType: constants.AccessCodeStatus })
	status!: constants.AccessCodeStatus | null;

}
